module.exports = __webpack_public_path__ + "img/bayadia.5bccd471.png";